import AdminModal from './AdminModal';
import theme from '../adminTheme';

/**
 * Modal de confirmación para acciones destructivas (eliminar, etc.).
 */
const ConfirmModal = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirmar',
  message = '¿Estás seguro?',
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  variant = 'danger', // 'danger' | 'primary'
  loading = false
}) => {
  const handleConfirm = () => {
    onConfirm();
    if (!loading) onClose();
  };

  const confirmStyle = variant === 'danger' ? theme.btnDanger : theme.btnPrimary;

  return (
    <AdminModal open={open} onClose={onClose} title={title}>
      <p style={{ margin: '0 0 24px', color: '#555', lineHeight: 1.5 }}>
        {message}
      </p>
      <div style={theme.modalActions}>
        <button
          type="button"
          style={theme.btnGhost}
          onClick={onClose}
          disabled={loading}
          aria-label={cancelLabel}
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          style={confirmStyle}
          onClick={handleConfirm}
          disabled={loading}
          aria-label={confirmLabel}
        >
          {loading ? 'Procesando...' : confirmLabel}
        </button>
      </div>
    </AdminModal>
  );
};

export default ConfirmModal;
